// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2GL-9","radioRow":"SimpleQuestionBuilderModal_radioRow__3T1LR"};